import { FC } from "react";
import { useSiteCore } from "../../hooks/useSiteCore";
import { MuiModal } from "./MuiModal";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { MuiTypography } from "../typography/MuiTypography";
import { InformationWrapper } from "./MuiModal.style";

interface InformationModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  handlePrimaryButtonClick: () => void;
  message: string;
  title?: string;
}
export const InformationModal: FC<InformationModalProps> = ({
  handleModalClose,
  showModal,
  handlePrimaryButtonClick,
  message,
  title,
}) => {
  const { commonLabels } = useSiteCore();
  return (
    <MuiModal
      id={COMPONENT_IDS.INFORMATION_MODAL}
      open={showModal}
      onClose={handleModalClose}
      title={title ?? commonLabels.information}
      primaryButtonTitle={commonLabels.ok}
      onPrimaryButtonClick={handlePrimaryButtonClick}
    >
      <InformationWrapper>
        <MuiTypography component="label" variant="h3" className="confirm-message">
          {message}
        </MuiTypography>
      </InformationWrapper>
    </MuiModal>
  );
};
